import { organizationShortNameOf } from 'App/domain/user';
import { useUserActiveRole } from './useUserActiveRole';

export const useOrganizationShortName = () => {
  return organizationShortNameOf(useUserActiveRole());
};
